import { render, staticRenderFns } from "./contactPerson.vue?vue&type=template&id=4e65728a&"
import script from "./contactPerson.vue?vue&type=script&lang=js&"
export * from "./contactPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e65728a')) {
      api.createRecord('4e65728a', component.options)
    } else {
      api.reload('4e65728a', component.options)
    }
    module.hot.accept("./contactPerson.vue?vue&type=template&id=4e65728a&", function () {
      api.rerender('4e65728a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/contactPerson.vue"
export default component.exports